export function formatEur(amount: number, locale = 'nl-NL'): string {
  return amount.toLocaleString(locale, { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 });
}

export function formatNum(n: number, locale = 'nl-NL'): string {
  return n.toLocaleString(locale);
}

export function formatDate(isoDate: string, locale = 'nl-NL'): string {
  return new Date(isoDate).toLocaleDateString(locale, { day: 'numeric', month: 'short', year: 'numeric' });
}

export function getQuarterOptions(count = 4): Array<{ value: string; label: string }> {
  const options: Array<{ value: string; label: string }> = [];
  const now = new Date();
  const currentQ = Math.floor(now.getMonth() / 3) + 1;
  const currentYear = now.getFullYear();

  for (let i = 0; i < count; i++) {
    let q = currentQ - i;
    let year = currentYear;
    while (q <= 0) { q += 4; year--; }
    options.push({ value: `Q${q}-${year}`, label: `Q${q} ${year}` });
  }
  return options;
}
